var map = {
	"./logo-fundis.png": 63364,
	"./logo-fundis.svg": 18370,
	"./logo-han-big.png": 23785,
	"./logo-han-big@2x.png": 98539,
	"./logo-han-big@3x.png": 40640,
	"./logo-hylyght.svg": 16478,
	"./logo-sport-vl-color.png": 34782,
	"./logo-sport-vl-transparent.png": 48045,
	"./logo-sport-vl-white.png": 41804,
	"./logo-sport-vlaanderen.png": 47932,
	"./logo-sportamundi.svg": 9949,
	"./logo-ugent.png": 52814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80119;